import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-8646a606-f4d4-45c6-8f7a-9f7a9efac03f-__Capa_1",
  "enable-background": "new 0 0 512 512",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "ec-f468b3ac-e69e-4373-825e-ef1818b4af7d-__Redo_1_",
      transform: "matrix(1.999997, 0, 0, 1.999997, -0.000061, 0.000435)"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("path", { d: "m11.558 450.61c-6.768-1.597-11.558-7.646-11.558-14.604 0-157.148 127.852-285 285-285h15v-75c0-5.815 3.369-11.118 8.643-13.579 5.229-2.49 11.484-1.685 15.967 2.051l181.994 150c3.633 3.032 5.625 7.603 5.376 12.334-.264 4.717-2.725 9.053-6.665 11.675l-181.994 120c-4.6 3.047-10.518 3.369-15.396.747-4.878-2.607-7.925-7.69-7.925-13.228v-75h-15c-141.123 0-217.427 93.369-256.582 171.709-3.035 6.088-9.911 9.499-16.86 7.895z" })
      ])
    ], -1)
  ])))
}
export default { render: render }